import { ChatToolCall } from '../../../../models/agentConversation'
import { ToolCallCard } from '../../App/Internal/AgentChat/ToolCallCard'
import { Demo, DsSection } from '../primitives'

function call(overrides: Partial<ChatToolCall> & { toolCallId: string }): ChatToolCall {
  return {
    tool: 'search_documents',
    label: 'Searching documents',
    icon: 'file-search',
    argsSummary: '{"query": "Big Sky Hauling"}',
    resultSummary: '3 results',
    error: null,
    ...overrides,
  }
}

// The icon is chosen server-side per tool — see `icon_for_tool` in
// backend/insure/services/agent/mcp_tools_config.py — so this sample covers the
// subjects a real thread mixes rather than one repeated glyph.
const RUN: ChatToolCall[] = [
  call({ toolCallId: '1', resultSummary: '0 results' }),
  call({
    toolCallId: '2',
    tool: 'search_businesses',
    label: 'Searching motor carriers',
    icon: 'truck',
    argsSummary: '{"query": "Big Sky Hauling"}',
    resultSummary: '0 results',
  }),
  call({
    toolCallId: '3',
    tool: 'search_sales_leads',
    label: 'Search sales leads',
    icon: 'target',
    resultSummary: '1 result',
  }),
  call({
    toolCallId: '4',
    tool: 'get_agent_conversation',
    label: 'Get agent conversation',
    icon: 'message-square',
    argsSummary: '{"conversation_id": "17deb58f-7372-4ae0-814c-192555562c41"}',
    resultSummary: '',
  }),
  call({
    toolCallId: '5',
    tool: 'send_email',
    label: 'Send email',
    icon: 'mail',
    argsSummary: '{"to": "ops@example.com"}',
    resultSummary: 'Sent',
  }),
  call({
    toolCallId: '6',
    tool: 'list_carriers',
    label: 'List carriers',
    icon: 'building-2',
    argsSummary: '',
    resultSummary: '12 carriers',
  }),
  call({ toolCallId: '7', resultSummary: '3 results' }),
]

/**
 * The tool trail the internal agent leaves above its answer. Rows, not cards:
 * no fill and no border, so a run of them reads as a quiet log rather than a
 * stack of boxes competing with the reply.
 */
export function ToolCallSection() {
  return (
    <DsSection
      id="tool-calls"
      title="Agent tool calls"
      intro="One row per tool the agent ran, rendered above its reply in the internal agent chat. Collapsed by default; a failed call expands itself so the error is visible without a click. A call with no arguments has nothing to reveal, so it gets no chevron."
    >
      <Demo label="A run of calls · 13px · icon chosen server-side per tool · row 6 has no args, so it does not expand">
        <div className="max-w-2xl space-y-2">
          {RUN.map((c) => (
            <ToolCallCard key={c.toolCallId} call={c} />
          ))}
        </div>
      </Demo>
      <Demo label="Failure · expanded by default">
        <div className="max-w-2xl">
          <ToolCallCard
            call={call({
              toolCallId: 'err',
              resultSummary: '',
              error: 'Document store unavailable',
            })}
          />
        </div>
      </Demo>
    </DsSection>
  )
}
